import { render, staticRenderFns } from "./SettingsWatermark.vue?vue&type=template&id=70cdb4b3&scoped=true&"
import script from "./SettingsWatermark.vue?vue&type=script&lang=js&"
export * from "./SettingsWatermark.vue?vue&type=script&lang=js&"
import style0 from "./SettingsWatermark.vue?vue&type=style&index=0&id=70cdb4b3&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "70cdb4b3",
  null
  
)

export default component.exports